import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_acc_8: FaireProductEntity = {
  token: "nyc-acc-8",
  type: "product",
  name: "Hudson Valley Wool Throw",
  brandName: "Upstate Textiles",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8fb4a9ff5cc7c0c0d2afc87eff190e471926c06931840d2956aeed437034d776.webp",
  priceDollars: 65,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/8fb4a9ff5cc7c0c0d2afc87eff190e471926c06931840d2956aeed437034d776.webp",
  weight: 2,
  dimensions: {
    width: 50,
    height: 60,
    depth: 2,
  },
  description: "Handwoven wool throw from Hudson Valley",
  categoryTokens: ["cat_accessories"],
  tags: ["nyc-local", "premium", "handmade", "wool"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
